<template>
  <div :class="classes" @click="$_onItemClick">
    <div v-if="!isLast" :class="`${prefixStepsClass}-tail`"><i></i></div>
    <div :class="`${prefixStepsClass}-step`">
      <div :class="`${prefixStepsClass}-head`">
        <div :class="`${prefixStepsClass}-head__inner`">
          <t-icon v-if="icon || status === 'finish' || status === 'error'" :class="prefixStepsClass+'-icon'" :icon="iconType"></t-icon>
          <span v-else :class="`${prefixStepsClass}-icon`">
            {{ stepNumber }}
          </span>
        </div>
      </div>
      <div :class="`${prefixStepsClass}-main`">
        <div :class="`${prefixStepsClass}-main__title`">{{ title }}</div>
        <div v-if="desc" :class="`${prefixStepsClass}-main__description`">{{ desc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_STEPS_CLASS = `${PREFIX_CLASS}steps`

export default {
  name: 'TStepItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    name: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      stepNumber: '',
      nextError: false,
      status: '',
      isLast: false,
      prefixStepsClass: PREFIX_STEPS_CLASS
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_STEPS_CLASS}-item`,
        `${PREFIX_STEPS_CLASS}-item--status-${this.status}`,
        {
          [`${PREFIX_STEPS_CLASS}-custom`]: !!this.icon,
          [`${PREFIX_STEPS_CLASS}-next-error`]: this.nextError
        }
      ]
    },
    iconType() {
      if (this.icon) {
        return this.icon
      }
      if (this.status === 'error' || this.icon === 'close') {
        return 'close'
      }
      if (this.status === 'finish') {
        return 'check-outline'
      }
      return ''
    }
  },
  mounted() {
    this.$parent.$emit('step-mounted', this)
  },
  destroyed() {
    this.$parent.$emit('step-destroyed')
  },
  methods: {
    $_onItemClick(event) {
      const $parent = this.$parent
      this.$emit('on-click', this.name, event)
      $parent.$emit('on-item-click', this.name, event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/steps/step-item.vue